import envConfig from './env.config';

const escConfig = {
  ...envConfig,
};

export default escConfig;
